module.exports = __webpack_public_path__ + "static/media/pr.0702734b.svg";